export const mapPanelStyle = {
  height: "100%",
  overflowY: "auto",
  background: "var(--color-bg-surface, #ffffff)",
  border: "1px solid var(--color-border-subtle, #d8e4ea)",
  borderRadius: "8px",
  boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
};

export const mapCanvasStyle = {
  background: "var(--color-bg-surface, #ffffff)",
  border: "1px solid var(--color-border-subtle, #d8e4ea)",
  borderRadius: "8px",
  boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
  overflow: "hidden",
};

export const mapSecondaryButtonStyle = {
  background: "var(--color-bg-surface, #ffffff)",
  border: "1px solid var(--color-border-default, #b8ccda)",
  color: "var(--color-text-primary, #0e1d2c)",
  fontSize: "0.875rem",
  fontWeight: 600,
  lineHeight: 1.25,
};

export const mapPrimaryButtonStyle = {
  background: "var(--color-action, #2569a3)",
  color: "#fff",
  border: "1px solid var(--color-action, #2569a3)",
  fontSize: "0.875rem",
  fontWeight: 600,
  lineHeight: 1.25,
};

export const mapFloatingPrimaryButtonStyle = {
  ...mapPrimaryButtonStyle,
  borderRadius: "0.375rem",
  padding: "0.5rem 0.75rem",
  fontSize: "0.9375rem",
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
};

export const mapOverlayInputStyle = {
  width: "100%",
  background: "var(--color-bg-surface, #ffffff)",
  color: "var(--color-text-primary, #0e1d2c)",
  border: "1px solid var(--color-border-default, #b8ccda)",
  borderRadius: "8px",
  padding: "0.375rem 0.5rem",
};
